"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var button_1 = __importDefault(require("relements/build/esm/ui/button"));
var loader_1 = __importDefault(require("relements/build/esm/ui/loader"));
var store_1 = __importDefault(require("@src/store"));
require("./TabContainer.scss");
var defaults = {
    title: 'Tab',
    marginTop: 24,
    isSaveDisabled: false,
    children: null,
    isLoaderActive: false,
    onSave: function () { return null; },
};
var TabContainer = function (_a) {
    var _b = _a === void 0 ? defaults : _a, title = _b.title, marginTop = _b.marginTop, isSaveDisabled = _b.isSaveDisabled, children = _b.children, isLoaderActive = _b.isLoaderActive, onSave = _b.onSave;
    return (react_1["default"].createElement("div", { className: "tabContainer " + (isLoaderActive && 'loading') + " " + (store_1["default"].getSelfServeLayout() ? 'ww' : '') },
        isLoaderActive && (react_1["default"].createElement(loader_1["default"], { className: "tabContainer-loader", prefixClassName: "tabContainer-loader" })),
        react_1["default"].createElement("div", { className: "tabContainer-header" },
            react_1["default"].createElement("div", { className: "tabContainer-header-title" }, title),
            react_1["default"].createElement(button_1["default"], { className: "tabContainer-header-button", type: button_1["default"].TYPES.PRIMARY, disabled: isSaveDisabled, onClick: onSave }, "Save")),
        react_1["default"].createElement("div", { className: "tabContainer-content", style: { marginTop: marginTop } }, children)));
};
exports["default"] = TabContainer;
